module.exports = {"id":"204638","name":"Willi Orban","rating":"80","photo":"./data/images/photos/4/204638.png","club":{"name":"RB Leipzig","logo":"./data/images/clubs/RBLeipzig.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/WilliOrban0.json
// module id = 4344
// module chunks = 0